import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { Location } from "@angular/common";
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { GenerateTicketModalComponent } from '../../ticketing/generate-ticket-modal/generate-ticket-modal.component';

@Component({
  selector: 'app-tickets-sold-landing',
  standalone: false,
  templateUrl: './tickets-sold-landing.component.html',
  styleUrl: './tickets-sold-landing.component.scss'
})
export class TicketsSoldLandingComponent  {
  action_idx: any = null;

  ticketList: any[] = [];
  form!: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedTicketNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 20;
  selectedLimit: number = 10;

  errorFetchingData: boolean = false;

  vehicleTypes: any[] = [];

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  clearSearchFilters() {
    this.form.reset()
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      ticketNumber: [''],
      ticketType: [''],
      subAgent: [''],
      from: [''],
      to: [''],
      offset: [''],

    });

    this.search();

    this.getAllVehicleTypes();
  }


  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();

  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data?.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  search() {
    this.ticketList = [];
    this.searchedTicketNotFound = false;
    this.errorFetchingData = false
    this.isSearching = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    const formValues = this.form.value;


    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);


    formValues.ticketNumber && formData.append('ticketNumber', formValues.ticketNumber.trim());
    formValues.subAgent && formData.append('subAgent', formValues.subAgent.trim());
    formValues.ticketType && formData.append('ticketType', formValues.ticketType);
    formValues.from && formData.append('from', formValues.from);
    formValues.to && formData.append('to', formValues.to);

    this.apiService
      .post('/ticket/sold/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedTicketNotFound = true;
          }



          this.ticketList = response.data;

        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true
        }
      );
  }

  back(){
    window.history.back()
  }
}
